import * as Yup from 'yup';

export const unit = Yup.string().when('category', {
  is: value => value !== 2,
  then: Yup.string().required('Unit is required'),
  otherwise: Yup.string().nullable(),
});
